"use client";

import React, { useState } from "react";
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import api from "../../services/api";
import Swal from "sweetalert2";

const OrderPayment = () => {
  const { orderCode } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const order =
    location.state?.order;

  const payableAmount =
    Number(
      order?.payableAmount ??
        order?.totalAmount ??
        order?.amount ??
        0
    );

  const [method, setMethod] =
    useState("CARD_TO_CARD");

  const [amount, setAmount] =
    useState(payableAmount);

  const [
    referenceNumber,
    setReferenceNumber,
  ] = useState("");

  const [loading, setLoading] =
    useState(false);

  const submitPayment = async (e) => {
    e.preventDefault();

    if (amount <= 0) {
      Swal.fire({
        icon: "warning",
        title: "مبلغ نامعتبر",
        text: "مبلغ پرداخت باید بیشتر از صفر باشد.",
        confirmButtonText:
          "باشه",
      });

      return;
    }

    if (
      method === "CARD_TO_CARD" &&
      !referenceNumber.trim()
    ) {
      Swal.fire({
        icon: "warning",
        title: "شماره پیگیری",
        text: "شماره پیگیری پرداخت را وارد کنید.",
        confirmButtonText:
          "باشه",
      });

      return;
    }

    setLoading(true);

    try {
      const payload = {
        amount: Number(amount),
        method,
      };

      if (
        method === "CARD_TO_CARD"
      ) {
        payload.referenceNumber =
          referenceNumber.trim();
      }

      const { data } =
        await api.post(
          `/payments/orders/${orderCode}`,
          payload
        );

      const payment =
        data?.data || data;

      Swal.fire({
        icon: "success",
        title: "پرداخت ثبت شد",
        text:
          payment?.message ||
          "پرداخت با موفقیت ثبت شد.",
        confirmButtonText:
          "مشاهده سفارش",
      }).then(() => {
        navigate("/user/stores");
      });
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "خطا در پرداخت",
        text:
          err?.response?.data?.message ||
          "ثبت پرداخت انجام نشد.",
        confirmButtonText:
          "باشه",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row>
      <Col lg={7}>
        <Card className="border-0 rounded-3">
          <Card.Body className="p-4">
            <h3 className="mb-4">
              پرداخت سفارش
            </h3>

            <Alert variant="info">
              مبلغ قابل پرداخت:
              <strong className="ms-2">
                {payableAmount.toLocaleString(
                  "fa-IR"
                )}{" "}
                تومان
              </strong>
            </Alert>

            <Form
              onSubmit={
                submitPayment
              }
            >
              <Form.Group className="mb-4">
                <Form.Label>
                  روش پرداخت
                </Form.Label>

                <Form.Select
                  value={method}
                  onChange={(e) => {
                    setMethod(
                      e.target.value
                    );

                    if (
                      e.target.value !==
                      "CARD_TO_CARD"
                    ) {
                      setReferenceNumber(
                        ""
                      );
                    }
                  }}
                >
                  <option value="CARD_TO_CARD">
                    کارت به کارت
                  </option>
                  {/*}<option value="WALLET">
                    کیف پول
                  </option>

                  <option value="CREDIT">
                    اعتبار
                  </option>{*/}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  مبلغ پرداخت
                </Form.Label>

                <Form.Control
                  type="number"
                  min="1"
                  value={amount}
                  onChange={(e) =>
                    setAmount(
                      e.target.value
                    )
                  }
                />

                <Form.Text>
                  امکان انجام چند پرداخت برای
                  یک سفارش نیز بر اساس وضعیت
                  سفارش وجود دارد.
                </Form.Text>
              </Form.Group>

              {method ===
                "CARD_TO_CARD" && (
                <Form.Group className="mb-4">
                  <Form.Label>
                    شماره پیگیری
                  </Form.Label>

                  <Form.Control
                    value={
                      referenceNumber
                    }
                    onChange={(e) =>
                      setReferenceNumber(
                        e.target.value
                      )
                    }
                    placeholder="شماره پیگیری کارت به کارت"
                  />
                </Form.Group>
              )}

              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="w-100"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      animation="border"
                      size="sm"
                    />{" "}
                    در حال ثبت پرداخت...
                  </>
                ) : (
                  "ثبت پرداخت"
                )}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default OrderPayment;